<template>
    <div class="">
        <modal-wf v-bind="getInputProps({})">
            <template #header-title>
                <slot name="header-title"></slot>
            </template>

            <template #trigger="{ click }">
                <slot name="trigger" :click="click">
                    <button
                        @click="click"
                        class="p-2 text-gray-400 hover:text-secondary transition-colors"
                    >
                        <i class="fa fa-pencil text-xl" aria-hidden="true"></i>
                    </button>
                </slot>
            </template>

            <template #body="{ close }">
                <div class="flex flex-col items-center text-center py-4">
                    <slot
                        name="content"
                        :icon="icon"
                        :title="title"
                        :text="text"
                        :msg="msg"
                        :isError="isError"
                    >
                        <div class="mb-6">
                            <template v-if="icon">
                                <div
                                    class="w-32 h-32 bg-contain bg-center bg-no-repeat mx-auto"
                                    :style="
                                        'background-image: url(' + icon + ');'
                                    "
                                ></div>
                            </template>
                            <template v-else>
                                <div
                                    class="w-24 h-24 bg-primary/5 rounded-full flex items-center justify-center mx-auto mb-4"
                                >
                                    <i :class="iconFont" class="text-4xl"></i>
                                </div>
                            </template>
                        </div>

                        <h3 class="text-xl font-semibold text-gray-900 mb-4">
                            {{ title }}
                        </h3>

                        <p
                            class="text-gray-500 text-sm leading-relaxed max-w-sm mx-auto"
                        >
                            {{ text }}
                        </p>

                        <div
                            v-if="isError"
                            class="mt-4 p-4 bg-red-50 rounded-2xl border border-red-100"
                        >
                            <p class="text-sm font-bold text-red-500">
                                {{ msg }}
                            </p>
                        </div>
                    </slot>

                    <div class="w-full grid grid-cols-2 gap-4 mt-10">
                        <button
                            class="wf-btn-light w-full"
                            @click.prevent="close"
                        >
                            {{ rejectLabel }}
                        </button>

                        <form-ajax ref="formAjax">
                            <template
                                #default="{ submit, getError, loading, msg }"
                            >
                                <form
                                    :action="url"
                                    :method="method"
                                    @submit.prevent="submit"
                                    class="w-full"
                                >
                                    <template v-if="token">
                                        <input
                                            type="hidden"
                                            name="_token"
                                            :value="token"
                                        />
                                    </template>
                                    <slot
                                        name="fields"
                                        :fields="fields"
                                        :submit="submit"
                                        :getError="getError"
                                        :loading="loading"
                                        :msg="msg"
                                    >
                                        <template v-for="field in fields">
                                            <input
                                                type="hidden"
                                                :name="field.name"
                                                :value="field.value"
                                            />
                                        </template>
                                    </slot>

                                    <button
                                        type="submit"
                                        class="wf-btn-primary w-full"
                                        :disabled="loading"
                                    >
                                        <span
                                            v-if="loading"
                                            class="animate-spin mr-2"
                                        >
                                            <svg
                                                class="w-4 h-4"
                                                fill="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    d="M12,1V4A8,8,0,0,1,12,20V23A11,11,0,0,0,12,1Z"
                                                ></path>
                                            </svg>
                                        </span>
                                        <span>{{ confirmLabel }}</span>
                                    </button>
                                </form>
                            </template>
                        </form-ajax>
                    </div>
                </div>
            </template>
        </modal-wf>
    </div>
</template>

<script>
import mixinCommon from "./mixinCommon.vue";
import Modal from "./Modal.vue";
import FormAjax from "./FormAjax.vue";

export default {
    mixins: [mixinCommon],
    components: {
        "modal-wf": Modal,
        "form-ajax": FormAjax,
    },
    props: {
        ...Modal.props,
        modalClassName: {
            type: String,
            default: "max-w-md",
        },
        url: {
            type: String,
            default: "",
        },
        method: {
            type: String,
            default: "POST",
        },
        title: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: "",
        },
        iconFont: {
            type: String,
            default: "fa fa-trash text-red-500",
        },
        confirmLabel: {
            type: String,
            default: "Yes",
        },
        rejectLabel: {
            type: String,
            default: "No",
        },
        showHeader: {
            type: [Boolean, Number, String],
            default: false,
        },
        showFooter: {
            type: [Boolean, Number, String],
            default: false,
        },
        token: {
            type: String,
            default: "",
        },
        fields: {
            type: Array,
            default: () => [],
        },
        defaultMsg: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            msg: this.defaultMsg,
            isError: false,
        };
    },
    mounted() {
        let formAjax = this.$refs.formAjax;
        if (formAjax && typeof formAjax.$watch === "function") {
            formAjax.$watch("msg", (response) => {
                this.msg = formAjax.$data.msg;
                this.isError = formAjax.$data.isError;
            });
        }
    },
    methods: {
        getInputProps(overrideProps = {}) {
            return this.getComponentProps(Modal, overrideProps);
        },
    },
};
</script>
